import styled from '@emotion/styled';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import Button from '@/components/comm/Button';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

export const BoardContentWrapDiv = styled.div`
display: grid;
margin-top: 32px;
row-gap: 60px;
`;

export const BoardWrapCenterDiv = styled.div`
display: flex;
justify-content: center;
`;

export const BoardBackListButton = styled(Button)`
width: 262px;
height: 46px;
`;

export const BoardItemDiv = styled.div`
display: flex;
width: 100%;
align-items: center;
justify-content: space-between;
padding: 15px 0;
column-gap: 10px;
@media (max-width: ${breakpointSmall}) {
  display: grid;
  row-gap: 8px;
}
`;

export const BoardTitleWrapDiv = styled.div`
display: flex;
align-items: center;
column-gap: 12px;
@media (max-width: ${breakpointSmall}) {
  column-gap: 5px;
}
`;

export const BoardTitleSpan = styled.span`
color: ${colors.black};
font-size: 18px;
font-weight: 400;
line-height: 24px;
text-overflow: ellipsis;
@media (max-width: ${breakpointSmall}) {
  font-size: 15px;
  line-height: 22px;
}
`;

export const BoardDateSpan = styled.span`
flex-shrink: 0;
color: ${colors.grey3};
font-size: 16px;
font-weight: 400;
line-height: 24px;
@media (max-width: ${breakpointSmall}) {
  font-size: 13px;
  line-height: 19px;
}
`;

export const BoardImage = (props: ImageProps) => (
  <div>
    <Image
      {...props}
      loader={({ src }) => src}
      width={100}
      height={55}
      sizes="50vw"
      style={{
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
      }}
      unoptimized
      priority
    />
  </div>
);
